import React from 'react';

import 'antd/lib/tabs/style/index.css';
import 'antd/lib/table/style/index.css';
import 'antd/lib/pagination/style/index.css';
import 'antd/lib/input/style/index.css';
import 'antd/lib/button/style/index.css';
import 'antd/lib/popover/style/index.css';
import 'antd/lib/spin/style/index.css';
import 'antd/lib/select/style/index.css';
import 'antd/lib/grid/style/index.css';
import 'antd/lib/form/style/index.css';
import 'antd/lib/space/style/index.css';
import 'antd/lib/switch/style/index.css';
import 'antd/lib/tooltip/style/index.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import '../main/utils/axios';

import { Provider } from 'react-redux';
import store from './store';
import Router from './Router';
import Alert from '../main/components/Alert';
import {
  LocalizationProvider,
  useLocalization,
} from '../../common/localization';
import { OnboardingLayout } from '../onboarding/OnboardingLayout';

function AppShell({ users }) {
  const { locales } = useLocalization();
  return (
    <>
      <OnboardingLayout data={{}} locales={locales}>
        <Router locales={locales} users={users} />
      </OnboardingLayout>
    </>
  );
}

export default function App({ locales, users }) {
  return (
    <Provider store={store}>
      <Alert />
      <LocalizationProvider initialLocales={locales}>
        <AppShell users={users} />
      </LocalizationProvider>
    </Provider>
  );
}
